<template>
  <div class="login">
    <div class="van-overlay" v-if="this.$store.getters.indexNotice">
      <van-loading
        type="spinner"
        color="#1989fa"
        :vertical="true"
        class="v-loading"
      />
    </div>
    <img class="logo" src="../assets/login/Btitle.png" />
    <img class="logoTitle" src="../assets/login/Ltitle.png" />
    <van-radio-group v-model="loginForm1.ltype" class="keepPassword">
      <van-radio name="2"   style="float:left;" checked-color="#ffffff">OA账号</van-radio>
      <van-radio name="1" style="float:right;" checked-color="#ffffff">外部账号</van-radio>
    </van-radio-group>
    <van-cell-group>
      <van-field
        v-model="loginForm1.username"
        placeholder="请输入用户名"
        class="inputCol"
      />
      <van-field
        v-model="loginForm1.password"
        :type="inpuType"
        placeholder="请输入密码"
        class="inputCo2"
      />
    </van-cell-group>
    <van-row type="flex" class="keepPassword">
      <van-checkbox v-model="checked">记住密码</van-checkbox>
    </van-row>
    <van-row type="flex" justify="center">
      <van-button type="primary" @click="login">登录</van-button>
    </van-row>
    <van-row type="flex" justify="space-between" class="fotgatPassword">
      <van-col class="btn-bottom" span="6" @click="toGetPwd">
        <router-link to="/person/getPwd">忘记密码</router-link>
      </van-col>
      <van-col span="6" class="btn-bottom-right" @click="toRegist">
        <router-link to="/person/Invitationregistration">注册</router-link>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import md5 from "js-md5";
import axios from "axios";
import qs from "qs";
import { setToken, setUser } from "@/utils/storage";
export default {
  data() {
    return {
      show: false,
      checked: true,
      radio:'1',
      // form表单数据对象
      loginForm1: {
        username: "", // 用户名称
        ltype: "2", // 
        password: "" // 用户密码
      },
      loginForm2: {
        username: "", // 用户名称
        ltype: 2, // 
        password: "" // 用户密码
      },
      inpuType: "password"
    };
  },
  created() {
    this.cok();
  },
  //进入该页面时，用之前保存的滚动位置赋值

  methods: {
    cok() {
      //将存储的密码赋值于密码框
      if (localStorage.getItem("psw")) {
        this.loginForm1 = JSON.parse(localStorage.getItem("psw"));
      }
    },
    async login() {
      let Toast = this.$toast;
      if (this.loginForm1.username == "") {
        Toast("请输入用户名");
      } else if (
        this.loginForm1.password == null ||
        this.loginForm1.password == ""
      ) {
        Toast("请输入密码");
      } else {
        if (this.checked) {
          localStorage.setItem("psw", JSON.stringify(this.loginForm1));
        } else {
          localStorage.removeItem("psw");
        }
   if(this.loginForm1.ltype==null || this.loginForm1.ltype==""){
      Toast("请选择登录方式！");
      return false;
   }
        this.loginForm2.username = this.loginForm1.username;
        this.loginForm2.password = md5(this.loginForm1.password);
        this.loginForm2.passwordmw = this.loginForm1.password;
        this.loginForm2.ltype = this.loginForm1.ltype*1;

        var data = await axios({
          method: "post",
          url: axios.defaults.baseURL + "/auth/login",
          data: qs.stringify(this.loginForm2)
        });
        var SystemTypeNum = "";
        var jobcode = data.user.job.JobCode;
        console.log(jobcode);
        if (
          jobcode == "gw" ||
          jobcode == "gwzz" ||
          jobcode == "xsjl" ||
          jobcode == "acld" ||
          jobcode == "fj"
        ) {
          SystemTypeNum = 2;
          console.log("案场+为了联盟");
        } else {
          SystemTypeNum = 1;
          console.log("托克+为了部落");
        }
        var currentCustom = this.currentCustom;
        this.$store.dispatch("SET_SYSTEMTYPE", currentCustom);
        localStorage.setItem("SystemTypeNumcokie", SystemTypeNum);
        // console.log(data.user);

        // 在前端通过localStorage把服务器返回的token令牌存储好
        //  window.localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        setToken(data.token);
        setUser(data.user);

        // 编程式导航，进行路由跳转执行/home
        this.$router.push("/home");
        localStorage.setItem("keepAlice",false)
      }
    },
    /* 找回密码 */
    toGetPwd() {
      this.$router.push({
        path: "/person/getPwd"
      });
    },
    /* 注册 */
    toRegist() {
      this.$router.push({
        path: "/person/Invitationregistration"
      });
    }
  }
};
</script>

<style lang="less">
.login {
  height: 100%;
  width: 100%;
  background: url(../assets/login/BG_login@2x.png) no-repeat;
  background-size: 100% 100%;
  background-position: center center;

  .logo {
    margin-top: 115px;
    width: 80%;
    margin-left: 10%;
    object-fit: cover;
  }

  .logoTitle {
    margin-top: 20px;
    margin-bottom: 75px;
    width: 80%;
    margin-left: 10%;
    object-fit: cover;
  }

  .inputCol {
    background: url(../assets/login/userIcon.png) no-repeat;
    background-position: 21px 14px;
    background-size: 14px 14px;
  }

  .inputCo2 {
    background: url(../assets/login/pswIcon.png) no-repeat;
    background-position: 21px 14px;
    background-size: 14px 14px;
  }

  .keepPassword {
    margin-top: 2px;
    padding: 0 10%;
    padding-bottom: 35px;
  }

  .van-icon {
    margin-top: 3px;
  }

  .fotgatPassword {
    font-size: 12px;
    color: #fff;
    padding: 0 10%;
    padding-top: 18px;

    .btn-bottom {
      color: white;
      background: transparent;
      font-size: 12px;
      line-height: 50px;
      text-align: left;
    }

    .btn-bottom-right {
      text-align: right;
      color: white;
      background: transparent;
      font-size: 12px;
      line-height: 50px;
    }
  }

  .van-checkbox__label,.van-radio__label {
    color: #fff;
    font-size: 12px;
    line-height: 0;
  }

  .van-cell-group {
    background: none;
    border: none;
  }

  .van-cell:not(:last-child)::after {
    border: none;
  }

  .van-hairline--top-bottom::after {
    border: none;
  }

  .van-cell {
    margin-left: 10%;
    width: 80%;
    height: 42px;
    background-color: #00539bff;
    opacity: 0.8;
    margin-bottom: 14px;
    border-radius: 3px;
  }

  .van-field__control {
    color: #fff;
    font-size: 15px;

    box-sizing: border-box;
  }

  .van-checkbox__icon--checked .van-icon{
    color: #fff;
  }
  .van-radio__icon--checked .van-icon {
    color: #fff;
    background:none;
    border-color:#fff;
  }

  .van-checkbox__icon .van-icon {
    background: none;

    width: 12px;
    height: 12px;

    font-size: 12px;
    border-radius: 0;
    border-color: #fff;
    line-height: 12px;
  }

  .van-radio__icon .van-icon {
    background: none;

    width: 12px;
    height: 12px;

    font-size: 12px;
    border-radius: 50%;
    border-color: #fff;
    line-height: 12px;
    margin-top:0;
  }

  .van-button {
    background-color: #fff;
    width: 80%;
    height: 46px;
    border-radius: 39px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(58, 91, 158, 1);
    line-height: 42px;
    border: none;
  }

  .van-field__control {
    text-indent: 54px;
  }

  .van-field__control::-webkit-input-placeholder {
    color: #fff;
  }

  .van-field__control::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #fff;
  }

  .van-field__control:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #fff;
  }

  .van-field__control:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #fff;
  }
}
</style>
